module.exports = __webpack_public_path__ + "img/saks3.2cb256d1.jpg";